import { useRouter } from 'next/router';
import React, { useState, useEffect, useRef } from 'react';

import './CourseModule.scss';
import { getString } from '../../helpers/styles';
import BackButton from '../BackButton/BackButton';
import Transition from '../Transition/Transition.jsx';
import icons from '../../shared/assets/icons/redesign';
import CoursesBuyPopup from '../CoursesBuyPopup/CoursesBuyPopup.jsx';
import CoursesLoginPopup from '../CoursesLoginPopup/CoursesLoginPopup.jsx';
import { trackAction, usePlatform } from '../../helpers/tracking';
import SurveyQuickForm from '../redesign/SurveyQuickForm/SurveyQuickForm.jsx';

const { ChevronLeft, ChevronRight, Check, Lock, StarFilled } = icons;

const reviewList = {
  zwangerschapscursus: [
    {
      author: 'Anna60',
      text: 'Super fijn',
      rating: 9
    },
    {
      author: 'Iris95',
      text: 'Uitgebreide informatie over zwangerschap en bevalling',
      rating: 10
    },
    {
      author: 'Sophie1993',
      text: 'Duidelijke en nuttige informatie',
      rating: 9
    },
    {
      author: 'EmmaMolen',
      text: 'Leerzaam en interessant',
      rating: 9
    },
    {
      author: 'LotteComics',
      text: 'Zeer informatief',
      rating: 10
    },
    {
      author: 'Eva92',
      text: 'Veel nieuwe inzichten',
      rating: 9
    }
  ],
  bevallingscursus: [
    {
      author: 'Fleur1704',
      text: 'Erg leuk',
      rating: 10
    },
    {
      author: 'Iris95',
      text: 'Meer inzicht in de bevalling',
      rating: 8
    },
    {
      author: 'AliciaRemon',
      text: 'Duidelijke info',
      rating: 9
    },
    {
      author: 'MelanieWirz',
      text: 'Informatief en nuttig',
      rating: 8
    },
    {
      author: 'Eleonora94',
      text: 'Zeer informatief en fijn',
      rating: 10
    },
    {
      author: 'Nikki41',
      text: 'Belangrijke informatie',
      rating: 9
    }
  ],
  borstvoedingscursus: [
    {
      author: 'MyrtheFlierman',
      text: 'Leerzaam en nuttig',
      rating: 9
    },
    {
      author: 'BernaRies',
      text: 'Prima, fijn om terug te kijken',
      rating: 9
    },
    {
      author: 'MerleWirz',
      text: 'Veel nieuwe informatie',
      rating: 7
    },
    {
      author: 'ShirleyDeGraaf',
      text: 'Duidelijke en goede info',
      rating: 9
    },
    {
      author: 'NathalieMebo',
      text: 'Leerzaam met vertrouwen',
      rating: 8
    },
    {
      author: 'CherylArlaud',
      text: 'Verschillende manieren geleerd',
      rating: 8
    }
  ],
  zwangerschapsyoga: [
    {
      author: 'ElineMartin',
      text: 'Prettig en informatief',
      rating: 9
    },
    {
      author: 'StephanieLuik',
      text: 'Veel geleerd',
      rating: 8
    },
    {
      author: 'RianneEnJoey13',
      text: 'Fijne oefeningen',
      rating: 8
    },
    {
      author: 'MaartjeCools91',
      text: 'Ondersteunend bij klachten',
      rating: 10
    },
    {
      author: 'RosanInags',
      text: 'Leuk en aangenaam',
      rating: 8
    },
    {
      author: 'CharlotteC2023',
      text: 'Goed en effectief',
      rating: 9
    }
  ],
  'sporten-en-bewegen': [
    {
      author: 'MaartjeCools91',
      text: 'Nuttige preventieve tips',
      rating: 9
    },
    {
      author: 'Ashley2803',
      text: 'Fijn en leerzaam',
      rating: 8
    },
    {
      author: 'StephanieLuik',
      text: 'Uitstekende uitleg',
      rating: 8
    },
    {
      author: 'AnoukBruining',
      text: 'Zeer behulpzaam',
      rating: 8
    },
    {
      author: 'Anne20227',
      text: 'Goed en informatief',
      rating: 8
    },
    {
      author: 'LauraVos',
      text: 'Praktische tips',
      rating: 8
    }
  ],
  babymassage: [
    {
      author: 'Yvonne110784',
      text: 'Interessant en leerzaam',
      rating: 8
    },
    {
      author: 'ChantalSenden',
      text: 'Informatief en nuttig',
      rating: 7
    },
    {
      author: 'LVanGelder85',
      text: 'Veel goede info',
      rating: 7
    },
    {
      author: 'Zomer2023',
      text: 'Zeer leerzaam',
      rating: 9
    },
    {
      author: 'LindaKraan',
      text: 'Uitstekend gepresenteerd',
      rating: 9
    },
    {
      author: 'IndyEnRuiz',
      text: 'Nuttig en informatief',
      rating: 9
    }
  ],
  voedingscursus: [
    {
      author: 'Maria26',
      text: 'Zeer informatief',
      rating: 9
    },
    {
      author: 'PetraBo',
      text: 'Nuttige inzichten',
      rating: 8
    },
    {
      author: 'EllenVos',
      text: 'Handige tips',
      rating: 9
    },
    {
      author: 'AnjaMeijer',
      text: 'Duidelijk en leerzaam',
      rating: 8
    },
    {
      author: 'IrisDeGroot',
      text: 'Goede basisinformatie',
      rating: 8
    },
    {
      author: 'LauraJansen',
      text: 'Praktisch en nuttig',
      rating: 9
    }
  ],
  'snelcursus-voor-de-partner': [
    {
      author: 'PeterVdV',
      text: 'Direct toepasbaar',
      rating: 8
    },
    {
      author: 'BasKo',
      text: 'Erg behulpzaam',
      rating: 9
    },
    {
      author: 'JoostW',
      text: 'Goede tips',
      rating: 8
    },
    {
      author: 'MarkDeRuiter',
      text: 'Duidelijk en nuttig',
      rating: 9
    },
    {
      author: 'SanderP',
      text: 'Praktisch en informatief',
      rating: 8
    },
    {
      author: 'RickVanD',
      text: 'Zeer aanbevolen',
      rating: 9
    }
  ],
  hypnobirthing: [
    {
      author: 'EvaSmits',
      text: 'Verhelderend',
      rating: 9
    },
    {
      author: 'SaraKlein',
      text: 'Ontspannend en nuttig',
      rating: 10
    },
    {
      author: 'MiekeVerbeek',
      text: 'Inzichtelijk en rustgevend',
      rating: 9
    },
    {
      author: 'NinaVanLoon',
      text: 'Zeer leerzaam',
      rating: 8
    },
    {
      author: 'LisaPeeters',
      text: 'Goede technieken',
      rating: 9
    },
    {
      author: 'KimDeBoer',
      text: 'Effectief en prettig',
      rating: 8
    }
  ],
  'babysignalen-en-baby-en-kinder-gebaren': [
    {
      author: 'SophieVanDijk',
      text: 'Leuk en leerzaam',
      rating: 8
    },
    {
      author: 'EmmaBakker',
      text: 'Interessant en praktisch',
      rating: 9
    },
    {
      author: 'AnneVanDerMeer',
      text: 'Geweldige cursus',
      rating: 10
    },
    {
      author: 'IrisDeHaan',
      text: 'Erg nuttig',
      rating: 9
    },
    {
      author: 'JuliaVerhoeven',
      text: 'Aanrader voor ouders',
      rating: 8
    },
    {
      author: 'NaomiHofman',
      text: 'Fantastisch en interactief',
      rating: 10
    }
  ],
  'seksualiteit-tijdens-en-na-de-zwangerschap': [
    {
      author: 'LauraS',
      text: 'Open en informatief',
      rating: 9
    },
    {
      author: 'AnoukV',
      text: 'Nuttige inzichten',
      rating: 10
    },
    {
      author: 'MirjamE',
      text: 'Respectvol en duidelijk',
      rating: 8
    },
    {
      author: 'PetraR',
      text: 'Belangrijk onderwerp goed behandeld',
      rating: 8
    },
    {
      author: 'IngeborgW',
      text: 'Leerzaam en belangrijk',
      rating: 8
    },
    {
      author: 'MariskaK',
      text: 'Zeer aanbevolen',
      rating: 10
    }
  ],
  'dragen-en-hechting': [
    {
      author: 'SanneDeVries',
      text: 'Praktisch en liefdevol',
      rating: 8
    },
    {
      author: 'LisaK',
      text: 'Geweldig voor ouder en kind',
      rating: 9
    },
    {
      author: 'KimP',
      text: 'Erg nuttig en ondersteunend',
      rating: 10
    },
    {
      author: 'EstherG',
      text: 'Goed voor hechting',
      rating: 8
    },
    {
      author: 'AnnekeB',
      text: 'Informatief en nuttig',
      rating: 7
    },
    {
      author: 'MoniqueVdL',
      text: 'Fantastische cursus',
      rating: 9
    }
  ]
};

export default function CourseModule({
  user,
  course,
  config,
  hasAccess,
  surveyForm,
  courseModule: {
    url,
    imageUrl,
    handoutUrl,
    displayName,
    description,
    subtitleUrl,
    prevCourseModuleName,
    nextCourseModuleName
  },
  addFormAnswer,
  refetchCourses,
  isInDepthCourse,
  submitFormAnswer,
  courseModuleWatch,
  currentCourseName,
  currentCourseModuleName
}) {
  const router = useRouter();
  const playerRef = useRef();
  const nextButton = useRef();
  const platform = usePlatform();
  const [scrolled, setScrolled] = useState(false);
  const [buyPopup, showBuyPopup] = useState(false);
  const [loginPopup, showLoginPopup] = useState(false);

  const isVideo = url.endsWith('.mp4');
  const isAudio = url.endsWith('.mp3');
  const isForm = !isVideo && !isAudio;

  const userAnswer = surveyForm?.formAnswers.find(
    ({ createdBy }) => createdBy === user.username
  );

  const prevModule = course.courseModules.find(
    (module) => module.name === prevCourseModuleName
  );
  const nextModule = course.courseModules.find(
    (module) => module.name === nextCourseModuleName
  );

  const prevButtonIsActive =
    prevModule && (hasAccess || prevModule.position === 'OPEN');
  const nextButtonIsActive =
    nextModule &&
    (hasAccess || nextModule.position === 'OPEN') &&
    (!surveyForm || (surveyForm && userAnswer));

  const Button = () =>
    (!user.username || (user.username && !user.hasAccess)) && (
      <div className="courseModule-links">
        <button
          onClick={() => router.push('/zwangerschapscursus/welkom')}
          className="courseModule-btn courseModule-btn-primary cursor-pointer"
        >
          Kies het pakket wat bij jou past
        </button>
      </div>
    );

  useEffect(() => {
    (async () => {
      if (isForm) return;

      await import('video.js/dist/video-js.css');
      const videojs = (await import('video.js')).default;

      isVideo &&
        videojs(playerRef.current, {
          fluid: true,
          controls: true,
          playbackRates: [0.5, 1, 1.5, 2],
          sources: [
            {
              src: url,
              type: 'video/mp4'
            }
          ]
        });
    })();
  }, [url]);

  useEffect(() => {
    document.addEventListener('scroll', () => !scrolled && setScrolled(true));
  }, []);

  return (
    <div className="courseModule">
      <Transition on={loginPopup}>
        <CoursesLoginPopup config={config} showPopup={showLoginPopup} />
      </Transition>

      <Transition on={buyPopup && hasAccess}>
        <CoursesBuyPopup showPopup={showBuyPopup} />
      </Transition>

      {isInDepthCourse && (
        <div style={{ marginBottom: '15px' }}>
          <BackButton />
        </div>
      )}

      {isForm ? (
        <div className="courseModule-survey-form">
          {surveyForm && (
            <SurveyQuickForm
              user={user}
              item={surveyForm}
              showCompletedHTML
              scrollTopOnPageChange
              CustomHTML={() => (
                <div className="courseModule-survey-form-completed-screen">
                  <div className="courseModule-survey-form-completed-screen-icon-wrap">
                    <Check className="courseModule-survey-form-completed-screen-icon" />
                  </div>

                  <h3 className="courseModule-survey-form-completed-screen-text">
                    Het forumlier is verzonden.
                  </h3>
                </div>
              )}
              addFormAnswer={addFormAnswer}
              showCompletedStage={userAnswer}
              submitFormAnswer={submitFormAnswer}
              onSubmit={() => {
                if (user.username)
                  courseModuleWatch({
                    variables: {
                      courseName: currentCourseName,
                      courseModuleName: currentCourseModuleName
                    }
                  }).then(() => refetchCourses());

                if (nextCourseModuleName)
                  nextButton.current.classList.add(
                    'courseModule-nav-button-active'
                  );
              }}
            />
          )}
        </div>
      ) : (
        <div className="courseModule-video">
          {isVideo ? (
            <div data-vjs-player>
              <video ref={playerRef} className="video-js">
                {subtitleUrl && (
                  <track
                    kind="captions"
                    src={subtitleUrl}
                    srcLang="en"
                    label="English"
                  />
                )}
              </video>
            </div>
          ) : (
            <audio
              className="video-js vjs-default-skin"
              controls
              preload="auto"
              data-setup="{}"
              poster={imageUrl}
            >
              <source src={url} type="audio/mp3" />
            </audio>
          )}
        </div>
      )}

      <div className="courseModule-nav">
        <button
          onClick={() => {
            if (prevCourseModuleName) {
              trackAction(
                platform,
                'coursescoursemodulepage',
                'clicknextbutton'
              );

              location.href = `/zwangerschapscursus/${
                isInDepthCourse ? 'ouder-en-kind/' : ''
              }${encodeURIComponent(course.name)}/${encodeURIComponent(
                prevCourseModuleName
              )}`;
            }
          }}
          className={getString([
            {
              value: 'courseModule-nav-button',
              condition: true
            },
            {
              value: 'courseModule-nav-button-active',
              condition: prevButtonIsActive
            }
          ])}
        >
          <ChevronLeft className="courseModule-nav-icon" />
          Vorige
        </button>

        <button
          ref={nextButton}
          onClick={() => {
            trackAction(
              platform,
              'coursescoursemodulepage',
              'clickpreviousbutton'
            );

            location.href = `/zwangerschapscursus/${
              isInDepthCourse ? 'ouder-en-kind/' : ''
            }${encodeURIComponent(course.name)}/${encodeURIComponent(
              nextCourseModuleName
            )}`;
          }}
          className={getString([
            {
              value: 'courseModule-nav-button',
              condition: true
            },
            {
              value: 'courseModule-nav-button-active',
              condition: nextButtonIsActive
            }
          ])}
        >
          Volgende
          <ChevronRight className="courseModule-nav-icon" />
        </button>
      </div>

      <h1 className="courseModule-name">{displayName}</h1>

      <img
        className="courseModule-provider-logo"
        src={course.userImageUrl}
        alt="provider-logo"
      />
      <span className="courseModule-provider-name">{course.username}</span>

      <div className="courseModule-description-wrap">
        <p className="courseModule-description">{description}</p>

        {handoutUrl && (
          <a download href={handoutUrl} className="courseModule-btn">
            Download handout
          </a>
        )}

        {!router.asPath.includes('/ouder-en-kind') &&
          router.asPath.includes('/introductievideo') && (
            <>
              <Button />

              {reviewList[course.name] && (
                <div className="courseModule-review">
                  <h2 className="courseModule-review-title">
                    Wat onze cursisten zeggen:
                  </h2>

                  <ul className="courseModule-review-list">
                    {reviewList[course.name].map((review, idx) => (
                      <li className="courseModule-review-list-item" key={idx}>
                        <span className="courseModule-review-list-item-author">
                          {review.author}
                        </span>

                        <span className="courseModule-review-list-item-rating">
                          <StarFilled /> {review.rating} / 10
                        </span>

                        <p className="courseModule-review-list-item-text">
                          {review.text}
                        </p>

                        <span className="courseModule-review-list-item-course-name">
                          {course.displayName}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </>
          )}
      </div>

      <ul className="courseModule-chapter-list">
        {[...course.courseChapters]
          .sort((a, b) => (+a.prio >= +b.prio ? 1 : -1))
          .map((chapter) => (
            <li className="courseModule-chapter-list-item" key={chapter.name}>
              <h3 className="courseModule-chapter-name">
                {chapter.displayName}
              </h3>

              <ul className="courseModule-module-list">
                {[...chapter.courseModules]
                  .sort((a, b) => (+a.prio >= +b.prio ? 1 : -1))
                  .map((module) => {
                    const isWatched =
                      module.isWatched ||
                      (!surveyForm &&
                        user.username &&
                        currentCourseModuleName === module.name);

                    const isOpen = module.position === 'OPEN';

                    return (
                      <li
                        key={module.name}
                        className={getString([
                          {
                            value: 'courseModule-module-list-item',
                            condition: true
                          },
                          {
                            value: 'courseModule-module-list-item-watched',
                            condition: isWatched
                          }
                        ])}
                        onClick={() => {
                          trackAction(
                            platform,
                            'coursescoursemodulepage',
                            'clickcoursemodule'
                          );

                          if (!isOpen) {
                            if (!user.username) return showLoginPopup(true);
                            if (!hasAccess) return showBuyPopup(true);
                          }

                          location.href = `/zwangerschapscursus/${
                            isInDepthCourse ? 'ouder-en-kind/' : ''
                          }${encodeURIComponent(
                            course.name
                          )}/${encodeURIComponent(module.name)}`;
                        }}
                      >
                        <div className="courseModule-module-checkmark">
                          {isWatched && (
                            <Check className="courseModule-module-checkmark-icon" />
                          )}
                        </div>

                        <h4
                          className="courseOverview-module-list-item-name"
                          dangerouslySetInnerHTML={{
                            __html: module.displayName
                          }}
                        />

                        {!isOpen && !hasAccess && (
                          <Lock className="courseModule-module-list-item-lock-icon" />
                        )}
                      </li>
                    );
                  })}
              </ul>
            </li>
          ))}
      </ul>

      <Button />

      <Transition on={scrolled}>
        {!router.pathname.includes('/ouder-en-kind') &&
          (!user.username || (user.username && !user.hasAccess)) && (
            <div className="fixed-bottom">
              <button
                onClick={() => router.push('/zwangerschapscursus/welkom')}
                className="courseModule-btn courseModule-btn-primary"
              >
                Kies het pakket wat bij jou past
              </button>
            </div>
          )}
      </Transition>
    </div>
  );
}
